/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Minimization_TitleInputs */

const en_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Data Minimization`)
};

const de_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Datenminimierung`)
};

const fr_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Minimisation des données`)
};

const es_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Minimización de datos`)
};

const it_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Minimizzazione dei dati`)
};

const nl_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Gegevensminimalisatie`)
};

const pl_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Minimalizacja danych`)
};

const fi_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Tietojen minimointi`)
};

const da_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Dataminimering`)
};

const sv_privacy_minimization_title = /** @type {(inputs: Privacy_Minimization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Dataminimering`)
};

/**
* | output |
* | --- |
* | "12. Data Minimization" |
*
* @param {Privacy_Minimization_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_minimization_title = /** @type {((inputs?: Privacy_Minimization_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Minimization_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_minimization_title(inputs)
	if (locale === "fr") return fr_privacy_minimization_title(inputs)
	if (locale === "es") return es_privacy_minimization_title(inputs)
	if (locale === "it") return it_privacy_minimization_title(inputs)
	if (locale === "nl") return nl_privacy_minimization_title(inputs)
	if (locale === "pl") return pl_privacy_minimization_title(inputs)
	if (locale === "fi") return fi_privacy_minimization_title(inputs)
	if (locale === "da") return da_privacy_minimization_title(inputs)
	if (locale === "sv") return sv_privacy_minimization_title(inputs)
	return en_privacy_minimization_title(inputs)
});